import React, { Component } from 'react'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { withRouter } from 'next/router'
const Error404 = dynamic(() => import('../../components/Error/404'))
import { get, headers } from '../../lib/fetch'
import {
  mapFiltersFromUrl,
  generateQueryString,
  convertFilters,
} from '../../lib/filterFormatter'
import getConfig from 'next/config'
const {
  publicRuntimeConfig: { DOMAIN_URL },
} = getConfig()
import { getLayoutByName } from '../../components/LoadLayout'
import { cookieValuetoJSON } from '../../lib/objectValidation'
import LayoutWithFilterAndSort from '../../components/LayoutWithFilterAndSort'
import { PAGE_TYPES } from '../../lib/eventTrackerFunction'
import { INFANT_FORMULA_CATEGORY } from '../../components/InfantFormulaPopup/InfantFormulaPopup'
const InfantFormulaPopup = dynamic(() =>
  import('../../components/InfantFormulaPopup/InfantFormulaPopup')
)
import { getActiveExperimentVariants } from '../../lib/getActiveExperimentVariants'
import { GlobalLoader } from '../../components/Loader/Loader'
import { getIosSmartBannerContent } from '../../utils/getIosSmartBannerContent'
import { getUserType } from '../../utils/userType'
import { CTA_LOCATION_NAME } from '../../lib/amplitude'
import {
  encodeSlugIfExist,
  isEncodedURIComponent,
  setCtaLocationMeta,
} from '../../lib/utils'
import _get from 'lodash/get'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import {
  initDyCookies,
  initDyParams,
  setDySessionFromLayout,
} from '../../utils/DyUtils'
const PRODUCT_LAYOUT_NANE = 'ProductCollection'
import getCanonicalUrl from '../../lib/getCanonicalUrl'

const getData = async (
  checkoutAddress,
  router,
  userkey,
  activeExperiments = ''
) => {
  // Calling DY for Headers
  const dyParams = initDyParams(router)
  const categoryRequestUrl = `layout/category/v2`
  const query = router.query
  const modifiedHeaders = headers(router)
  if (typeof window === 'undefined') {
    modifiedHeaders['user-agent'] = router?.req?.headers['user-agent']
  }
  const queryStringObject = {
    category: isEncodedURIComponent(query.slug)
      ? query.slug
      : encodeSlugIfExist(query.slug),
    url: isEncodedURIComponent(query.slug)
      ? query.slug
      : encodeSlugIfExist(query.slug),
    q: query?.query || '',
    layoutType: 'GRID',
    page: 1,
    storeId: (checkoutAddress && checkoutAddress.storeId) || null,
    orderType: getUserType(router) === 'B2B' ? 'B2B' : 'DELIVERY',
  }
  if (activeExperiments.length) {
    const { configuration } = getConfigFor(
      SPLIT_FEATURES.ALGOLIA_PERSONALISATION
    )
    const { personalisationSettings } = configuration
    queryStringObject.algopers = personalisationSettings
    queryStringObject.experiments = activeExperiments
  }

  if (query.filter) {
    const transferredFilter = mapFiltersFromUrl(query.filter)
    queryStringObject.filter = convertFilters(transferredFilter)
  }
  if (query.sorting) {
    queryStringObject.sorting = query.sorting
  }

  queryStringObject.includeTagDetails = true

  // default call
  const api =
    categoryRequestUrl + generateQueryString(queryStringObject) + dyParams
  const response = await get(api, {
    headers: {
      ...modifiedHeaders,
      'x-device-Id': userkey,
    },
  })
  return { data: response?.data }
}

class CategoryDetails extends Component {
  static async getInitialProps(ctx) {
    const userkey = ctx.res
      ? _get(ctx, 'res.locals.userKey')
      : window.__NEXT_DATA__.props.userKey
    const iosSmartBannerContent = getIosSmartBannerContent(ctx)
    const user_type = getUserType(ctx)
    const checkoutAddress = cookieValuetoJSON(
      ctx,
      user_type === 'B2B' ? 'b2bCheckoutAddress' : 'checkoutAddress'
    )
    const activeExperiments =
      getActiveExperimentVariants(ctx) || ctx.experiments
    const response = await getData(
      checkoutAddress,
      ctx,
      userkey,
      activeExperiments
    )
    return {
      data: { data: response.data },
      iosSmartBannerContent,
      userType: user_type,
      userkey,
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      pageData: { data: props.data?.data } || [],
    }
    this.initiateApiRequest = this.initiateApiRequest.bind(this)
    this.getSchema = this.getSchema.bind(this)
  }

  componentDidMount() {
    setDySessionFromLayout(this.props.data?.data?.page?.layouts)
    setCtaLocationMeta([
      this.props.data?.data?.page?.entity?.slug,
      this.props.data?.data?.page?.entity?.id,
    ])
    initDyCookies()
  }

  async initiateApiRequest() {
    const activeExperiments = getActiveExperimentVariants()
    const response = await getData(
      this.props.checkoutAddress,
      this.props.router,
      this.props.userkey,
      activeExperiments
    )
    setDySessionFromLayout(response?.data?.page?.layouts)
    this.setState({
      pageData: { data: response.data },
      loading: false,
    })
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.checkoutAddress.storeId !==
        this.props.checkoutAddress.storeId &&
      this.props.checkoutAddress.storeId
    ) {
      this.setState({ loading: true })
      this.initiateApiRequest()
    }

    if (
      prevProps.router.query.slug !== this.props.router.query.slug ||
      prevProps.router.query.filter !== this.props.router.query.filter ||
      prevProps.router.query.sorting !== this.props.router.query.sorting
    ) {
      this.setState({
        loading: false,
        pageData: this.props.data,
      })
    }

    const data = this.state.pageData

    const layouts = data?.data?.page?.layouts || []
    const productLayout = getLayoutByName(layouts, PRODUCT_LAYOUT_NANE)
    if (!productLayout) {
      return
    }
    const productValue = productLayout && productLayout.value
    if (this.state.productCollection !== productValue) {
      this.setState({
        productCollection: productValue,
      })
    }
  }

  getSchema(pageTitle, metaInfo, details) {
    const data = details.map((item, index) => {
      return `{
        "@type": "ListItem",
        "position": ${index + 1},
        "url": "${DOMAIN_URL}/product/${item.slug}",
        "name": "${item.name}",
        "description": "Shop for ${
          item.name
        } from Singapore's trusted grocery retailer. FairPrice offers a wide range of products with prices matched online and in stores."
    }`
    })

    return `{
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "${pageTitle}",
      "description": "${metaInfo}",
      "itemListElement": [${data}]
    }`
  }
  render() {
    const {
      organizationData,
      categoryList,
      router,
      iosSmartBannerContent,
      userType,
    } = this.props
    const respData = this.state.pageData
    const seoData = respData?.data?.page?.entity?.seo || {}
    const name = seoData?.name || ''
    const pageTitle =
      seoData?.title || `Shop ${name} For Everyday Great Value | NTUC FairPrice`
    const metaInfo =
      seoData?.description ||
      `Shop ${name} at Singapore's trusted grocery retailer. FairPrice offers a wide range of products to choose from!`
    const layouts = respData?.data?.page?.layouts || []
    const firstProductLayout = getLayoutByName(layouts, PRODUCT_LAYOUT_NANE)
    const productCollections = layouts.filter(
      layout => layout.name === PRODUCT_LAYOUT_NANE
    )
    const isEmptyLayout =
      !productCollections.length ||
      productCollections.every(pc => pc.value?.collection?.count === 0)
    const firstProductSwimlaneValue =
      firstProductLayout?.value?.collection?.product || []
    let linkPointDisclaimerInfo = {}
    if (userType !== 'B2B') {
      linkPointDisclaimerInfo = respData?.data?.page?.entity?.linkpoint
    }
    if (isEmptyLayout) {
      return (
        <Error404
          organizationData={organizationData}
          categoryList={categoryList}
        />
      )
    } else {
      return (
        <React.Fragment>
          <Head>
            <title>{pageTitle}</title>
            <meta
              name="description"
              key="meta_description"
              content={metaInfo}
            />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={pageTitle} />
            <meta
              property="og:image"
              content={
                firstProductSwimlaneValue.length
                  ? firstProductSwimlaneValue[0]?.images?.[0]
                  : null
              }
            />
            <meta property="og:site_name" content="FairPrice" />
            <meta name="apple-itunes-app" content={iosSmartBannerContent} />
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: this.getSchema(
                  pageTitle,
                  metaInfo,
                  firstProductSwimlaneValue
                ),
              }}
            />
            <link rel="canonical" href={getCanonicalUrl(router.asPath)} />
          </Head>
          {this.state.loading && <GlobalLoader />}
          <LayoutWithFilterAndSort
            title={respData?.data?.page?.entity?.name || ''}
            layouts={layouts}
            organizationData={organizationData}
            preLoadFirstImage={true}
            categoryList={categoryList}
            seoDataToShow={seoData?.content}
            ctaLocation={{
              pageName: CTA_LOCATION_NAME.CATEGORY,
              pageMeta: [
                this.props.data?.data?.page?.entity?.slug,
                this.props.data?.data?.page?.entity?.id,
              ],
            }}
            config={{
              pageType: PAGE_TYPES.CATEGORY,
              url: router?.query?.slug,
              loc: `ProductListing-${PAGE_TYPES.CATEGORY}`,
            }}
            linkPointDisclaimerInfo={linkPointDisclaimerInfo}
            filterExcept={['PWP', 'isEndlessAisle']}
          />
          {Object.values(INFANT_FORMULA_CATEGORY).includes(
            this.props.data?.data?.page?.entity?.slug
          ) && (
            <InfantFormulaPopup
              categorySeen={this.props.data?.data?.page?.entity?.slug}
            />
          )}
        </React.Fragment>
      )
    }
  }
}

export default withRouter(CategoryDetails)
